import React from 'react';
import ReactDOM from 'react-dom';

import App from '@/App/App';

const loginButton = document.getElementById('loginButton') as IdKamigameLoginButton;
if (loginButton) {
  const renderApp = () => {
    ReactDOM.render(<App />, document.getElementById('app'));
  };

  if (loginButton.loaded) {
    renderApp();
  }
  loginButton.addEventListener('load', renderApp);
}
